import React, { useCallback, useEffect, useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Button, Form, Image } from "react-bootstrap";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../store";
import { getVendorUserById } from "../../store/auth/authActions";
import { api_url } from "../../api/config/config";
import { VENDOR_ROLES } from "../../config/const";

interface VendorDepartmentUserStructure {
    id: number,
    last_name: string,
    first_name: string,
    title: string,
    role: string,
    status: string,
    bids: {
        aggregate: {
            count: number
        }
    },
    contracts: {
        aggregate: {
            count: number
        }
    },
    [key: string]: any;
}

interface VendorDepartmentStructure {
    id: number,
    name: string,
    users: VendorDepartmentUserStructure[],
    [key: string]: any;
}

interface VendorDepartmentDataStructure {
    id: number,
    name: string,
    post_code: number,
    pref: string,
    address1: string,
    address2: string,
    phone: string,
    vendor_departments: VendorDepartmentStructure[]
}

interface VendorDepartmentResponseStructure {
    success: boolean;
    data: VendorDepartmentDataStructure;
}


interface VendorRole {
    id: string, role: string, name: string
}


const AccountEdit: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const search = useLocation().search;
    const URLquery = new URLSearchParams(search);

    const { userInfo, userToken, error: userError } = useSelector((state: RootState) => state.auth);
    const { vendorInfo, loading: vendorLoading, error: vendorError } = useSelector((state: RootState) => state.vendor);
    // const [vendorDepartmentInfo, setVendorDepartmentInfo] = useState<VendorDepartmentStructure[]>([]);
    // const [vendorDepartments, setVendorDepartments] = useState();
    // const [vendorDepartmentId, setVendorDepartmentId] = useState(vendorInfo?.vendor_department_id);
    // const [lastName, setLastName] = useState(vendorInfo?.last_name);
    // const [firstName, setFirstName] = useState(vendorInfo?.first_name);
    // const [lastNameKana, setLastNameKana] = useState(vendorInfo?.last_name_kana);
    // const [firstNameKana, setFirstNameKana] = useState(vendorInfo?.first_name_kana);
    // const [title, setTitle] = useState(vendorInfo?.title);
    // const [role, setRole] = useState(vendorInfo?.role);
    // const [phone, setPhone] = useState(vendorInfo?.phone);
    // const [email, setEmail] = useState(vendorInfo?.email);

    const [userId, setUserId] = useState<string | null>(URLquery.get('id'));
    const [vendorId, setVendorId] = useState<number>();
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [vendorDepartmentInfo, setVendorDepartmentInfo] = useState<VendorDepartmentStructure[]>([]);
    const [vendorDepartmentId, setVendorDepartmentId] = useState<number>();
    // const [vendorDepartments, setVendorDepartments] = useState<any[]>([]); 
    const [lastName, setLastName] = useState<string>('');
    const [firstName, setFirstName] = useState<string>('');
    const [lastNameKana, setLastNameKana] = useState<string>('');
    const [firstNameKana, setFirstNameKana] = useState<string>('');
    const [title, setTitle] = useState<string>('');
    const [role, setRole] = useState<string>();
    const [phone, setPhone] = useState<string>('');
    const [email, setEmail] = useState<string>('');

    const fetchVendorUserById = async (user_id: string) => {
        const response = await fetch(`${api_url}/getVendorUserById`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: user_id, request_user_id: userInfo?.id }),
        });

        const res: any = await response.json();
        if (res.status !== "success") return navigate('/account');

        return res.data;
    }

    const fetchVendorById = async (vendor_id: string) => {
        const response = await fetch(`${api_url}/getVendorById`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ vendor_id: vendor_id }),
        });

        const res: VendorDepartmentResponseStructure = await response.json();
        return res.data;
    }


    const fetchVendorInfo = useCallback(async () => {
        try {

            if (userId) {
                const user = await fetchVendorUserById(userId);
                const vendor = await fetchVendorById(user.vendor_id);
                setVendorDepartmentId(user.vendor_department_id);
                setVendorId(user.vendor_id);
                setLastName(user.last_name);
                setFirstName(user.first_name);
                setLastNameKana(user.last_name_kana);
                setFirstNameKana(user.first_name_kana);
                setTitle(user.title);
                setRole(user.role);
                setPhone(user.phone_number);
                setEmail(user.email);
                setVendorDepartmentInfo(vendor.vendor_departments);

            }


        } catch (error) {
            console.error('Error:', error);
        }
    }, [])



    const ConvertSelectedDepartmentToId = (select: string) => {
        const selectedDepartment = vendorDepartmentInfo.find((department => department.name === select));
        if (selectedDepartment) setVendorDepartmentId(selectedDepartment.id);
    }

    const handleSubmit = async () => {
        try {
            const roleId = VENDOR_ROLES.find(roleItem => roleItem.role == role)?.id || '';
            await fetch(`${api_url}/updateVendorUserById`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: userId,
                    last_name: lastName,
                    last_name_kana: lastNameKana,
                    first_name: firstName,
                    first_name_kana: firstNameKana,
                    email: email,
                    vendor_department_id: vendorDepartmentId,
                    title: title,
                    role: roleId,
                    phone: phone,
                    vendor_id: vendorId,
                }),
            });


            // 更新処理
            if (userInfo) {
                await dispatch(getVendorUserById({ id: userInfo?.id }));
                navigate('/account_edit_completed');
            }

        } catch (error) {
            console.error('Error:', error);
        }
    }

    useEffect(() => {
        fetchVendorInfo();
    }, [fetchVendorInfo])


    return (
        <>
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 mx-auto">
                            <div className="login-wrapper py-lg-4 py-3 text-center">
                                <Image className="height-90 mb-2" src="/assets/images/other/icon-user-bg-white-circle-blue.svg" />
                                <div className="text-md mb-sm-4 mb-3 fw-400">アカウント情報を編集</div>
                                <Form id="account-form" className="form-theme" method="post">
                                    <div className="border-bottom-5-blue-04"></div>
                                    <div className="bg-ass-demo p-lg-5 p-3 mb-lg-5 mb-sm-4 mb-3">
                                        <div className="col-lg-8 col-11 px-0 mx-auto">
                                            <Form.Group className="text-left mb-4">
                                                <Form.Label htmlFor="name1">氏名</Form.Label>
                                                {
                                                    isConfirmed ? <>
                                                        <hr className="mt-0 mb-2" />
                                                        <div className="text-theme fw-400">{lastName} {firstName}</div>
                                                        <div className="text-theme fw-400">{lastNameKana} {firstNameKana}</div>
                                                    </> :
                                                        <div className="row mx-0">
                                                            <div className="col-md-6 pl-0 pr-0 pr-md-1 mb-2">
                                                                <Form.Control
                                                                    type="text"
                                                                    value={lastName}
                                                                    disabled={isConfirmed}
                                                                    onChange={(e) => setLastName(e.target.value)}
                                                                    className="rounded-0"
                                                                    name="last_name"
                                                                    required placeholder="姓" />
                                                            </div>
                                                            <div className="col-md-6 pl-0 pr-0 pl-md-1 mb-2">
                                                                <Form.Control
                                                                    type="text"
                                                                    value={firstName}
                                                                    disabled={isConfirmed}
                                                                    onChange={(e) => setFirstName(e.target.value)}
                                                                    className="rounded-0"
                                                                    name="first_name"
                                                                    required placeholder="名" />
                                                            </div>
                                                            <div className="col-md-6 pl-0 pr-0 pr-md-1 mb-2">
                                                                <Form.Control
                                                                    type="text"
                                                                    value={lastNameKana}
                                                                    disabled={isConfirmed}
                                                                    onChange={(e) => setLastNameKana(e.target.value)}
                                                                    className="rounded-0"
                                                                    name="last_name_kana"
                                                                    required placeholder="セイ" />
                                                            </div>
                                                            <div className="col-md-6 pl-0 pr-0 pl-md-1 mb-2">
                                                                <Form.Control
                                                                    type="text"
                                                                    value={firstNameKana}
                                                                    disabled={isConfirmed}
                                                                    onChange={(e) => setFirstNameKana(e.target.value)}
                                                                    className="rounded-0"
                                                                    name="first_name_kana"
                                                                    required placeholder="メイ" />
                                                            </div>
                                                        </div>
                                                }


                                            </Form.Group>
                                            <Form.Group className="text-left mb-4">
                                                <Form.Label htmlFor="customSelect">部署</Form.Label>

                                                {
                                                    isConfirmed ? <>
                                                        <hr className="mt-0 mb-2" />
                                                        <div className="text-theme fw-400">
                                                            {vendorDepartmentInfo && vendorDepartmentInfo.find(department => department.id == vendorDepartmentId)?.name}
                                                            {/* {vendorDepartmentId ? vendorDepartments[vendorDepartmentId] : ''} */}
                                                        </div>
                                                    </>
                                                        : vendorInfo?.role == 'vendor_admin' ?
                                                            (
                                                                <Form.Select onChange={e => ConvertSelectedDepartmentToId(e.target.value)} className="custom-select theme-form-select rounded-0" id="department" name="vendor_department_id">
                                                                    {vendorDepartmentInfo && vendorDepartmentInfo.map((dept: VendorDepartmentStructure, index: any) => (
                                                                        <option
                                                                            selected={dept.id == vendorDepartmentId}
                                                                            disabled={isConfirmed}
                                                                            value={dept.id}>
                                                                            {dept.name}
                                                                        </option>
                                                                    ))}


                                                                </Form.Select>
                                                            )
                                                            :
                                                            (
                                                                <>
                                                                    {/* <Form.Control type="hidden" name="vendor_department_id" /> */}
                                                                    <Form.Control type="text"
                                                                        value={vendorDepartmentInfo && vendorDepartmentInfo.find(department => department.id == vendorDepartmentId)?.name}
                                                                        className="form-control rounded-0" disabled />
                                                                </>
                                                            )
                                                }

                                            </Form.Group>
                                            <Form.Group className="text-left mb-4">
                                                <Form.Label for="customSelect">役職</Form.Label>
                                                {
                                                    isConfirmed ?
                                                        <>
                                                            <hr className="mt-0 mb-2" />
                                                            <div className="text-theme fw-400">
                                                                {title}
                                                            </div>
                                                        </> :
                                                        <Form.Control onChange={(e) => setTitle(e.target.value)}
                                                            disabled={isConfirmed} type="text" value={title} className="rounded-0" name="title" placeholder="役職" />
                                                }
                                            </Form.Group>
                                            <Form.Group className="text-left mb-4">
                                                <Form.Label htmlFor="customSelect">権限</Form.Label>
                                                {isConfirmed ? <>
                                                    <hr className="mt-0 mb-2" />
                                                    <div className="text-theme fw-400">
                                                        {VENDOR_ROLES.find(roleItem => roleItem.role == role)?.name}
                                                    </div>
                                                </> :
                                                    // role === "vendor_admin"
                                                    vendorInfo?.role == 'vendor_admin' ? (
                                                        <Form.Select onChange={(e) => setRole(e.target.value)}
                                                            className="custom-select theme-form-select rounded-0" name="role">
                                                            {/* <option
                                                            disabled={isConfirmed}
                                                            //onChange={(e) => setRole(e.target.value)} 
                                                            value={role}></option> */}

                                                            {
                                                                VENDOR_ROLES.map((vendor_role: VendorRole, index: number) => {
                                                                    return <option value={vendor_role.role}
                                                                        // onChange={(e) => setRole(e.target.value)}
                                                                        selected={vendor_role.role == role}>
                                                                        {vendor_role.name}
                                                                    </option>
                                                                })
                                                            }
                                                        </Form.Select>
                                                    ) :
                                                        (
                                                            <>
                                                                <Form.Control type="hidden" name="role" />
                                                                <Form.Control type="text" className="rounded-0" disabled value={VENDOR_ROLES.find(roleItem => roleItem.role == role)?.name} />
                                                            </>
                                                        )
                                                }
                                            </Form.Group>
                                            <Form.Group className="text-left mb-4">
                                                <Form.Label htmlFor="name1">電話番号</Form.Label>
                                                {isConfirmed ?
                                                    <>
                                                        <hr className="mt-0 mb-2" />
                                                        <div className="text-theme fw-400">
                                                            {phone}
                                                        </div>
                                                    </> :
                                                    <Form.Control
                                                        type="text"
                                                        disabled={isConfirmed}
                                                        value={phone}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                        className="rounded-0" name="phone"
                                                        required placeholder="電話番号" />
                                                }
                                            </Form.Group>
                                            <Form.Group className="text-left mb-4">
                                                <Form.Label htmlFor="name1">メールアドレス</Form.Label>
                                                {
                                                    isConfirmed ? <>
                                                        <hr className="mt-0 mb-2" />
                                                        <div className="text-theme fw-400">
                                                            {email}
                                                        </div>

                                                    </>
                                                        :
                                                        <Form.Control
                                                            type="text"
                                                            value={email}
                                                            className="rounded-0"
                                                            required placeholder="メールアドレス" disabled />
                                                }
                                            </Form.Group>
                                        </div>
                                    </div>
                                </Form>
                                <div className="py-3 mb-3 text-center">
                                    {!isConfirmed ? (
                                        <>
                                            <Button type="button" id="submit" onClick={() => { setIsConfirmed(true) }} className="btn-theme btn-danger rounded-pill px-5 mr-2"><span className="mx-3">次へ</span></Button>
                                            <Link to="/account" type="button" className="btn btn-theme btn-secondary rounded-pill px-4">編集をキャンセル</Link>
                                        </>
                                    ) : (
                                        <>
                                            <Button type="submit" onClick={handleSubmit} className="btn btn-theme btn-danger rounded-pill px-4 mr-2">この内容で変更する</Button>
                                            <Link to="#" type="button" onClick={() => { setIsConfirmed(false) }} className="btn btn-theme btn-secondary rounded-pill px-4">入力内容を修正</Link>
                                        </>
                                    )}


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default AccountEdit;